import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  roles: 'roles',
  rolesSubject: 'roles/role-subjects',
  create: 'roles/role-permission',
  update: 'roles/role-permission'
};

const RolesService = {
  getAllRoles: (companyId: number | string) => RequestService.get(`${endpoints.roles}/company/${companyId}`),
  getAllRoleSubjects: () => RequestService.get(endpoints.rolesSubject),
  create: (data: any) => RequestService.post(endpoints.create, data),
  update: (id: number, data: any) => RequestService.patch(`${endpoints.update}/${id}`, data),
};

export default RolesService;